const config = {
  endpointBaseUrl: "",
  keycloakServerUrl: "",
  keycloakClient: "",
  dateFormat: "DD/MM/YYYY",
  dateTimeFormat: "DD/MM/YYYY HH:mm",
  dateFormatBE: "YYYY-MM-DD",
  dateTimeFormatBE: "YYYY-MM-DDTHH:mm:ss.SSSZ",
  shortResultsPerPage: 10,
  minResultsPerPage: 5,
  resultsPerPage: 20,
  results50PerPage: 50,
  results100PerPage: 100,
  results1000PerPage: 1000,
  results15PerPage: 15,
  toasterShowTime: 10000,
  dataForecastsEndpointBaseUrl: "",
  serviceDeskEndpointBaseUrl: "",
  env: "",
  defaultNotificationAddress: "notifications@goodshapecentral.com",
  defaultEmailAppearAs: "GoodShapeCentral",
};

if (typeof window === "object" && window.location && window.location.host) {
  const hostname = window.location.hostname;
  const hostIdentifier = hostname.match(/(www\.?)?goodshapecentral\.(com|net)/);
  config.keycloakClient = "goodshape-central-fe";

  if (hostIdentifier) {
    // PROD ENV
    const subDomainIdentifier = hostname.match(/\w+\.([a-z\-]+)\.goodshapecentral\.(com|net)/);

    if (subDomainIdentifier && subDomainIdentifier.length === 3) {
      config.endpointBaseUrl = `https://api.${subDomainIdentifier[1]}.goodshapecentral.com/`;
      config.keycloakServerUrl = `https://login.${subDomainIdentifier[1]}.goodshapecentral.com/auth`;
      config.dataForecastsEndpointBaseUrl = `https://mymlops.${subDomainIdentifier[1]}.goodshapecentral.com/`;
      config.serviceDeskEndpointBaseUrl = `https://service-desk.${subDomainIdentifier[1]}.goodshapecentral.com/`;
      config.env = subDomainIdentifier[1];
    } else {
      config.endpointBaseUrl = "https://api.goodshapecentral.com/";
      config.keycloakServerUrl = `https://login.goodshapecentral.com/auth`;
      config.dataForecastsEndpointBaseUrl = `https://mymlops.goodshapecentral.com/`;
      config.serviceDeskEndpointBaseUrl = `https://service-desk.goodshapecentral.com/`;
      config.env = "prod";
    }
  } else {
    // TEST ENV
    const subDomainIdentifier = hostname.match(/\w+\.([a-z\-]+)\.goodshapecentral\.com/);

    if (subDomainIdentifier && subDomainIdentifier.length === 2) {
      config.endpointBaseUrl = `https://api.${subDomainIdentifier[1]}.goodshapecentral.com/`;
      config.keycloakServerUrl = `https://login.${subDomainIdentifier[1]}.goodshapecentral.com/auth`;
      config.dataForecastsEndpointBaseUrl = `https://mymlops.${subDomainIdentifier[1]}.goodshapecentral.com/`;
      config.serviceDeskEndpointBaseUrl = `https://service-desk.${subDomainIdentifier[1]}.goodshapecentral.com/`;
      config.env = subDomainIdentifier[1];
    }
  }

  if (hostname === "localhost") {
    config.endpointBaseUrl = `https://api.test.goodshapecentral.com/`;
    config.keycloakServerUrl = `https://login.test.goodshapecentral.com/auth`;
    config.dataForecastsEndpointBaseUrl = `https://mymlops.test.goodshapecentral.com/`;
    config.serviceDeskEndpointBaseUrl = `https://service-desk.test.goodshapecentral.com/`;
    config.keycloakClient = "goodshape-central-fe-local";
    config.env = "test";
  }
}

export default config;
